import { render, staticRenderFns } from "./affiliate-review-page-self-assessment.vue?vue&type=template&id=2ff25fc2&scoped=true&"
import script from "./affiliate-review-page-self-assessment.vue?vue&type=script&lang=ts&"
export * from "./affiliate-review-page-self-assessment.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-review-page-self-assessment.vue?vue&type=style&index=0&id=2ff25fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff25fc2",
  null
  
)

export default component.exports